'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _url_utility = require('../../../packages/common-utilities/src/url_utility');

var _url_utility2 = _interopRequireDefault(_url_utility);

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ESGApproachCard = function (_React$Component) {
    _inherits(ESGApproachCard, _React$Component);

    function ESGApproachCard(props) {
        _classCallCheck(this, ESGApproachCard);

        var _this = _possibleConstructorReturn(this, (ESGApproachCard.__proto__ || Object.getPrototypeOf(ESGApproachCard)).call(this, props));

        _this.updateLearnMoreLink = function (country, language, originalLink) {
            var visibleDataPoints = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

            if (!visibleDataPoints.includes('ESG_LEARN_MORE_LINK_CAPABILITIES')) {
                return originalLink;
            }
            var esgCapabilities = '../investment-themes/esg/capabilities/';
            var susCapabilities = '../investment-themes/sustainable-investing/capabilities/';
            var countryLangLinks = {
                it: {
                    it: susCapabilities
                },
                ch: {
                    fr: susCapabilities,
                    en: esgCapabilities,
                    de: originalLink
                }
            };
            return (0, _ramda.pathOr)(esgCapabilities, [country, language], countryLangLinks);
        };

        _this.renderESGApproach = _this.renderESGApproach.bind(_this);
        _this.renderSFDRClassification = _this.renderSFDRClassification.bind(_this);
        _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
        return _this;
    }

    _createClass(ESGApproachCard, [{
        key: 'renderSFDRClassificationRow',
        value: function renderSFDRClassificationRow(flag, label, value, dataTest, icon) {
            return flag && React.createElement(
                'div',
                { className: "row margin-all-0 padding-top-16 category" },
                React.createElement(
                    'div',
                    { className: "white-space-default", 'data-testid': "esg-integrated-approach-sfdr-row" },
                    React.createElement(
                        'div',
                        { className: "text-left display-inline-block width-percent-70 white-space-default", 'data-testid': dataTest + '-label' },
                        _string_utility2.default.renderFormattedLabel(label, 'pdp-overview-' + dataTest + '-label'),
                        '\xA0',
                        icon
                    ),
                    React.createElement(
                        'div',
                        { className: "text-right display-inline-block width-percent-30 float-right", 'data-testid': dataTest + '-value' },
                        value
                    )
                )
            );
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon(tooltipId) {
            var _this2 = this;

            if (!this.props.fund.disclosures || (0, _ramda.isNil)(this.props.fund.disclosures[tooltipId])) {
                return null;
            }

            return React.createElement(
                'span',
                { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide padding-left-2',
                    role: 'tooltip',
                    onKeyDown: function onKeyDown(event) {
                        return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
                    },
                    onClick: function onClick(event) {
                        return _this2.handleDisclosureIconClick(event, tooltipId);
                    }
                },
                ' '
            );
        }
    }, {
        key: 'handleDisclosureIconClick',
        value: function handleDisclosureIconClick(event, tooltipId) {
            var el = event.target;
            var elHeight = el.offsetHeight;
            var elWidth = el.parentNode.getBoundingClientRect().left;
            var elRect = el.getBoundingClientRect();
            var arrowHeight = 4;
            var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

            var toolTipWidth = void 0,
                toolTipContentWidth = void 0,
                closeTipPosition = void 0,
                toolTipContentScroll = 'hidden';
            if (this.props.fund.disclosures[tooltipId][0].length > 380) {
                if (this.props.breakpoint > 3) {
                    elWidth -= 150;
                    toolTipWidth = 570;
                    toolTipContentWidth = 530;
                    closeTipPosition = 530;
                } else {
                    toolTipContentScroll = 'auto';
                }
            }
            var elOffset = {
                top: elRect.top + docTop + arrowHeight + elHeight,
                left: elWidth,
                arrowPosition: elRect.left - elWidth - 3,
                toolTipWidth: toolTipWidth,
                toolTipContentWidth: toolTipContentWidth,
                closeTipPosition: closeTipPosition,
                toolTipContentScroll: toolTipContentScroll
            };

            if (!(0, _ramda.isNil)(this.props.tooltip)) {
                this.props.tooltip.openTooltip(elOffset, this.props.fund.disclosures[tooltipId], null, true, event);
            } else {
                this.props.showTooltip(event, this.props.fund.disclosures[tooltipId]);
            }
        }
    }, {
        key: 'renderESGApproach',
        value: function renderESGApproach() {
            var _props = this.props,
                country = _props.country,
                language = _props.language,
                role = _props.role;


            var showCTALink = true;
            if (country === 'ie' || role === 'nra' || role === 'ml' || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_ESG_SUSTAINABLE_INVESTMENT_LINK')) {
                showCTALink = false;
            }

            var esgApproachFlag = void 0,
                esgApproachDefaultLabel = void 0,
                esgApproachContent = void 0,
                esgApproachContentHardCoded = void 0,
                esgApproachContentHardCodedBold = void 0,
                showLearnESGApproach = void 0,
                learnMoreLabel = void 0,
                learnMoreLink = void 0;
            esgApproachFlag = "title";
            esgApproachDefaultLabel = "ESG Integrated";
            esgApproachContentHardCoded = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content");
            if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ESG_INTEGRATED_CARD_HARDCODED_BOLD_DISCLOSURE')) {
                if (!this.props.fund.esgData.esgBestInClassFlag && !this.props.fund.esgData.esgPositiveTiltFlag && !this.props.fund.esgData.esgThemeBasedFlag && !this.props.fund.esgData.esgPromoteFlag && !this.props.fund.esgData.esgExlusionsFlag) {
                    esgApproachContentHardCodedBold = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content-bold");
                }
            }
            showLearnESGApproach = false;
            if (this.props.fund.esgData.esgBestInClassFlag) {
                esgApproachFlag = "esgBestInClassFlag";
                esgApproachDefaultLabel = "Best-in-Class";
                esgApproachContent = "pdpDataPointBestInClass";
                esgApproachContentHardCoded = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content-best-in-class");
                showLearnESGApproach = true;
                esgApproachContentHardCodedBold = "";
            } else if (this.props.fund.esgData.esgPositiveTiltFlag) {
                esgApproachFlag = "esgPositiveTiltFlag";
                esgApproachDefaultLabel = "Positive tilt";
                esgApproachContent = "pdpDataPointPositiveTilt";
                esgApproachContentHardCoded = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content-positive-tilt");
                showLearnESGApproach = true;
                esgApproachContentHardCodedBold = "";
            } else if (this.props.fund.esgData.esgThemeBasedFlag) {
                esgApproachFlag = "esgThemeBasedFlag";
                esgApproachDefaultLabel = "Thematic";
                esgApproachContent = "pdpDataPointThematic";
                esgApproachContentHardCoded = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content-thematic");
                showLearnESGApproach = true;
                esgApproachContentHardCodedBold = "";
            } else if (this.props.fund.esgData.esgPromoteFlag) {
                esgApproachFlag = "esgPromoteFlag";
                esgApproachDefaultLabel = "ESG promote";
                esgApproachContent = "pdpDataPointESGPromote";
                esgApproachContentHardCoded = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content-promote");
                showLearnESGApproach = true;
            } else if (this.props.fund.esgData.esgExlusionsFlag) {
                esgApproachFlag = "esgExlusionsFlag";
                esgApproachDefaultLabel = "Exclusions";
                esgApproachContent = "pdpDataPointExclusions";
                esgApproachContentHardCoded = _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content-exclusions");
                showLearnESGApproach = true;
                esgApproachContentHardCodedBold = "";
            }

            if (showLearnESGApproach) {
                learnMoreLabel = _string_utility2.default.renderFormattedLabel("Learn more about sustainable investing approaches", "pdp-overview-esg-integrated-card-learn-more-about-approaches");
                learnMoreLink = "../investment-themes/sustainable-investing/capabilities/";
                if (role === 'per') {
                    learnMoreLink = "../investment-themes/esg/";
                }
                if (role === 'institutional') {
                    learnMoreLink = "../investment-strategies/sustainable-investing/capabilities/";
                }
                if (country === 'sg' || country === 'tw') {
                    learnMoreLink = "../investment-ideas/sustainable-investing/capabilities/";
                }
                if (country === 'au' || country === 'hk') {
                    learnMoreLink = "../insights/investment-ideas/sustainable-investing/capabilities/";
                }
                if (country === 'jp') {
                    learnMoreLink = "../funds/sustainable-investing/capabilities/";
                }
            } else {
                learnMoreLabel = _string_utility2.default.renderFormattedLabel("Learn more about ESG Integration", "pdp-overview-esg-integrated-card-learn-more");
                learnMoreLink = _url_utility2.default.generateESGLearnMoreUrl(country, language, role);
            }

            learnMoreLink = this.updateLearnMoreLink(country, language, learnMoreLink, this.props.fund.visibleData.visibleDataPoints);

            var finalEsgApproachContent = void 0;
            if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ESG_INTEGRATED_CARD_HARDCODED_CONTENT')) {
                finalEsgApproachContent = esgApproachContentHardCoded;
            } else {
                finalEsgApproachContent = esgApproachContent ? React.createElement('span', {
                    dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.fund.disclosures[esgApproachContent]) } }) : _string_utility2.default.renderFormattedLabel("", "pdp-overview-esg-integrated-card-content", { fundType: this.props.fund.fundTypeCode });
            }
            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'text-left tag white-space-default padding-bottom-20', 'data-testid': 'esg-approach-label' },
                    _string_utility2.default.renderFormattedLabel(esgApproachDefaultLabel, 'pdp-overview-esg-integrated-card-' + esgApproachFlag)
                ),
                React.createElement(
                    'div',
                    { className: 'category', 'data-testid': 'esg_integrated_card_content-text' },
                    finalEsgApproachContent,
                    country === 'tw' && esgApproachContentHardCodedBold !== "" && React.createElement(
                        'span',
                        { className: "white-space-newLine" },
                        React.createElement(
                            'b',
                            null,
                            esgApproachContentHardCodedBold
                        )
                    )
                ),
                showCTALink && React.createElement(
                    'div',
                    { className: 'padding-top-20 tag', 'data-testid': 'esg-integrated-learn-more-link' },
                    React.createElement(
                        'a',
                        { className: 'font-teal', target: '_blank', href: learnMoreLink },
                        learnMoreLabel
                    )
                )
            );
        }
    }, {
        key: 'renderSFDRClassification',
        value: function renderSFDRClassification() {
            var SFDRValueToDisplay = _string_utility2.default.renderFormattedLabel(this.props.fund.sdfrClassificationValue, 'esg-integrated-sfdr-' + _string_utility2.default.customKebabCase(this.props.fund.sdfrClassificationValue));
            var SFDRIcon = this.renderIcon("pdpDataPointSfdrClassification");

            var showSFDR = this.props.fund.sdfrClassificationValue && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_SDFR_CLASSIFICATION_ESG_INTEGRATED_CARD');
            var showSFDRLink = showSFDR && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_ESG_INTEGRATED_SFDR_LINK');
            var SFDRLink = this.props.role === 'institutional' ? '../investment-strategies/sustainable-investing/understanding-SFDR/' : '../investment-themes/sustainable-investing/understanding-SFDR/';

            return React.createElement(
                'div',
                null,
                this.renderSFDRClassificationRow(showSFDR, "SFDR Classification", SFDRValueToDisplay, "esg-integrated-sdfr-classification", SFDRIcon),
                showSFDRLink && React.createElement(
                    'div',
                    { className: 'padding-top-16 tag', 'data-testid': 'esg-integrated-sfdr-link' },
                    React.createElement(
                        'a',
                        { className: 'font-teal', target: '_blank', href: SFDRLink },
                        _string_utility2.default.renderFormattedLabel("Understanding SFDR", "pdp-overview-esg-integrated-card-sfdr-link")
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var disclosureText = this.props.fund.esgApproachDisclosure;

            if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_AEM_ESG_DISCLOSURE') && !(0, _ramda.isNil)(this.props.fund.disclosures.pdpESGApproach)) {
                disclosureText = this.props.fund.disclosures.pdpESGApproach.concat(this.props.fund.esgApproachDisclosure);
            }

            return React.createElement(
                _card_component2.default,
                {
                    placementId: this.props.placementId,
                    headerTitle: _string_utility2.default.renderFormattedLabel("ESG Approach", "pdp-overview-esg-integrated-approach-label"),
                    headerTitleId: "esg_approach_card",
                    headerTitleLabel: "esg_approach_card",
                    headerLabel: "",
                    breakpoint: this.props.breakpoint,
                    disclosureText: disclosureText,
                    shouldAlwaysShowMore: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ALWAYS_SHOW_MORE_DISCLOSURES')
                },
                React.createElement(
                    'div',
                    { 'data-testid': 'esg_approach_card_content', id: 'esg_approach_card_content' },
                    this.renderESGApproach(),
                    this.renderSFDRClassification()
                )
            );
        }
    }]);

    return ESGApproachCard;
}(React.Component);

exports.default = ESGApproachCard;